<div class="cmfas-section" [formGroup]="formGroup">
  <!-- Header -->
  <div class="section-header">Section A: SCI CMFAS Qualifications</div>

  <!-- Note -->
  <div class="section-note">
    Please tick (✔) where applicable and insert ‘E’ for Exempted modules.<br />
    <!-- <span>
      (Copies of professional qualifications are required. Original copies are to be sighted and signed off by BDM)
    </span> -->
  </div>

  <!-- Grid -->
  <div class="row g-3">
    @for (item of cmfasList; track item.control) {

    @let control = formGroup.get(item.control);


    <div class="col-md-3 col-6">

      <mat-label class="field-label">{{ item.label }}</mat-label>

      <mat-form-field class="w-100">
        <mat-select [formControlName]="item.control" (selectionChange)="uploadValidation(item.control)">
          @if(['m5', 'm9', 'hi'].includes(item.control)){
          <mat-option value="yes">Yes</mat-option>
          }@else if(['m9a'].includes(item.control)){
          <mat-option value="yes">Yes</mat-option>
          <mat-option value="E">Exempted</mat-option>
          }@else if(['lip','lic','gi'].includes(item.control)){
          <mat-option value="yes">Yes</mat-option>
          <mat-option value="no">No</mat-option>
          }
          @else{
          <mat-option value="yes">Yes</mat-option>
          <mat-option value="no">No</mat-option>
          <mat-option value="E">Exempted</mat-option>
          }
        </mat-select>
        @if(control?.invalid && (control?.touched ||
        control?.dirty)) {
        <mat-error>
          @if(control?.errors?.['required']) {
          <span>{{message}}</span>
          }@else {
          <span></span>
          }
        </mat-error>
        }
      </mat-form-field>


      <!-- ✅ Upload Section -->
      @if (control?.value === 'yes') {
      <!-- Date Section -->
      <mat-label>Choose a date</mat-label>
      <mat-form-field>
        <input matInput [matDatepicker]="picker" [formControlName]="item.control+'_Date'" placeholder="DD/MM/YYYY">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        @let datecontrol = formGroup.get(item.control+'_Date');
        @if(datecontrol?.invalid && (datecontrol?.touched ||
        datecontrol?.dirty)) {
        <mat-error>
          @if(datecontrol?.errors?.['required']) {
          <span>{{message}}</span>
          }@else {
          <span></span>
          }
        </mat-error>
        }
      </mat-form-field>
      <div class="upload-box">
        @let fileControl = formGroup.get(item.control + '_file');
        <!-- Hidden File Input -->
        <input type="file" [disabled]="readonly()" #fileInput [id]="item.control" accept=".pdf,.jpg,.jpeg,.png"
          (change)="onFileChange($event, item.control,item.label)" hidden />

        @if(readonly() == false){
        <!-- Upload Button -->
        <button mat-stroked-button color="primary" (click)="fileInput.click()">
          Upload {{ item.label }}
        </button>
        }

        <!-- File Preview -->
        @if (uploadedFiles[item.control]) {
        <div class="file-preview">
          {{ uploadedFiles[item.control]?.name }}
          @if(readonly() == false){
          <button mat-icon-button color="primary" class="delete-btn"
            (click)="removecmfaFile(item.control,item.label)">
            <mat-icon>close</mat-icon>
          </button>
          }
          <button mat-icon-button color="primary" class="delete-btn"
          (click)="previewcmfaFileAttachment(item.control,item.label)">
          <mat-icon>visibility</mat-icon>
          </button>
        </div>
        }

      </div>
      
      @if(fileControl?.invalid && (fileControl?.touched || fileControl?.dirty)){
      <mat-error>
        @if(fileControl?.errors?.["required"]) {
        <span>{{message}}</span>
        }@else if(fileControl?.errors?.['invalidType']){
        <span>Only PDF, JPG, PNG files are allowed.</span>
        }
        @else if(fileControl?.errors?.['maxSize']){
        <span>File size must be less than or equal to 5MB.</span>
        }
        @else {
        <span></span>
        }
      </mat-error>
      }
      }
    </div>


    }
   
    <br />
    <mat-divider></mat-divider>
    <br />
    <div class="section-header">
      @if (isUploadRequired()) {
      <div class="upload-warning">
        <strong>Documents required for:</strong>
        {{ getSelectedCmfas().join(', ') }}
      </div>
      }
      Section B: For other Qualifications (e.g. AWP, AFC, ChFC)
    </div>
    <div [formArrayName]="controlName">
      <div *ngFor="let item of formArray.controls; let i = index" [formGroupName]="i"
        class="qualification-card row g-3 align-items-end">
        <!-- Date Range -->
        <!--Date of attainment -->
        <div class="col-md-6">
          <mat-label class="field-label">Date of Attainment(MM/YYYY)(Optional)</mat-label>
          <mat-form-field class="w-100">
            <input matInput monthYearDateFormat formControlName="dateofAttainment" [matDatepicker]="picker1"
              placeholder="MM/YYYY" />
            <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1 startView="multi-year" (monthSelected)="setdateofAttainment($event, picker1,i)"
              panelClass="month-picker"></mat-datepicker>
            @let dateofAttainment = item.get('dateofAttainment');

            @if(dateofAttainment?.invalid && (dateofAttainment?.touched || dateofAttainment?.dirty)) {
            <mat-error>
              @if(dateofAttainment?.errors?.['required']) {
              <span>{{message}}</span>
              }@else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>


        <!-- Qualification -->
        <div class="col-md-6">
          <label class="field-label">Professional Qualification(Optional)</label>
          <mat-form-field class="w-100">
            <input matInput formControlName="professionalQualification" />
            @let professionalQualification = item.get('professionalQualification');

            @if(professionalQualification?.invalid && (professionalQualification?.touched ||
            professionalQualification?.dirty)) {
            <mat-error>
              @if(professionalQualification?.errors?.['required']) {
              <span>{{message}}</span>
              }@else {
              <span></span>
              }
            </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="row g-3">
          <!-- Institution -->
          <div class="col-md-6">
            <label class="field-label">Name of Professional Body(Optional)</label>
            <mat-form-field class="w-100">
              <input matInput formControlName="professionalbody" />
              @let professionalbody = item.get('professionalbody');

              @if(professionalbody?.invalid && (professionalbody?.touched ||
              professionalbody?.dirty)) {
              <mat-error>
                @if(professionalbody?.errors?.['required']) {
                <span>{{message}}</span>
                }@else {
                <span></span>
                }
              </mat-error>
              }
            </mat-form-field>
          </div>


          <div class="col-md-6">
            <label class="field-label">Upload Document</label>

            <div class="upload-container">
              <div class="upload-box">
                <input type="file" id="fileName" [disabled]="readonly()" accept=".pdf,.jpg,.jpeg,.png"
                  (change)="onFileChange1($event, i)">
                <input type="text" formControlName="fileName" hidden>
                @let documentControl = item.get('fileName');

                @if(!documentControl?.value){
                <!-- Show filename OR placeholder -->
                <span>
                  Choose a file
                </span>
                }
                @if(documentControl?.value){
                <div class="attachment-row">
                  <span class="file-name">
                    {{ documentControl?.value }}
                  </span>
                  @if(readonly() === false){
                  <button mat-icon-button color="primary" class="delete-btn"
                    (click)="removeFile('fileName','file',i)">
                    <mat-icon>close</mat-icon>
                  </button>
                  }
                  <button mat-icon-button color="primary" class="delete-btn"
                    (click)="previewAttachment('fileName',i)">
                    <mat-icon>visibility</mat-icon>
                   </button>
                </div>
                }
              </div>
            </div>
            @if(documentControl?.invalid && (documentControl?.touched || documentControl?.dirty)) {
            <mat-error>
              @if(documentControl?.errors?.["required"]) {
              <span>{{message}}</span>
              }@else if(documentControl?.errors?.['invalidType']){
              <span>Only PDF, JPG, PNG files are allowed.</span>
              }
              @else if(documentControl?.errors?.['maxSize']){
              <span>File size must be less than or equal to 5MB.</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </div>
        </div>

        <!-- Delete -->
        <div class="col-md-3 text-end">
          @if (formArray.length > 1 && readonly() == false) {
          <button mat-stroked-button color="warn" type="button" (click)="deleteRow(i)"><mat-icon>delete</mat-icon>Delete
            Qualification</button>
          }
        </div>

      </div>
      @if(readonly() === false){
      <!-- Add Button -->
      <div class="text-end mt-3">
        <button mat-stroked-button color="primary" type="button" (click)="addRow()">+ Add Qualification</button>
      </div>
      }
    </div>
  </div>
</div>
@if(readonly() === false){
@if(isVisible() === true){
<div class="editor-actions">
  <button mat-stroked-button type="button" (click)="cancelSection()">Cancel</button>
  <button type="button" class="save-btn" (click)="saveSection()">
    <mat-icon>save</mat-icon>
    Save
  </button>
</div>

}@else {
<!-- Form Actions -->
<div class="form-actions">
  <button class="save-btn" (click)="saveAndContinue()">
    <span>Save & Continue</span>
    <mat-icon>arrow_forward</mat-icon>
  </button>
</div>

}

}